import React from 'react'
import "./index.css"
export const Footer = () => {
  return (
    <div className='footerContain' style={{position:"relative"}}>
      <div style={{position:"absolute", bottom:0}}>
      <p className='p_footer'>© Boyero De Berna Club Argentino - Desarrollado por Luca Ramos y Alejo Avendaño</p>
      <div className='div_footer'>
        <ul className='ul_footer'>
          <li>Términos y condiciones</li>
          <li>|</li>
          <li>Contacto</li>
        </ul>
      </div>

      </div>
    </div>
  )
}

// Desarrollado por NM Comunicaciones™. Córdoba Kennel Club© Todos los derechos rerservados.

// Términos y condiciones
 
// Contacto
